import { Element , scroller  } from "react-scroll";
import React, { Suspense , useEffect} from "react";
import CompanyBasicSection from 'components/company/companybasicsection';
//import Investorsection from 'components/company/investorsection';
import CompanyAboutSection from 'components/company/companyAboutSection';
import Peersection from 'components/company/peersection';
//import QuarterResultSection from 'components/company/quarterresultsection';
import RatioSection from 'components/company/ratiosection';
import BalancesheetSection from 'components/company/balancesheetsection'; 
import CashFlowSection from 'components/company/cashflowsection';
import ProfitNLossSection from 'components/company/profitNlosssection';
import StockChartSection from 'components/company/stockchartsection';
import Forumsection from 'components/company/forumsection';
//import AnalysisSection from 'components/company/analysissection';
import CompanyNews from '../../pages/news/CompanyNews'
//import CompanyFAQ from 'components/company/company-faq';
import Loaderanimation from 'components/ui/loaderanimation';
import { useCompanyFin } from "contexts/companyfindata/companyfindata.context.tsx";
import CompanyConcall from '../../pages/concall/CompanyConcall';

const QuarterResultSection = React.lazy(() =>
  import('components/company/quarterresultsection')
);

const AnalysisSection = React.lazy(() =>
  import('components/company/analysissection')
);
const Investorsection = React.lazy(() =>
  import('components/company/investorsection')
);
const CompanyFAQ = React.lazy(() =>
  import('components/company/company-faq')
);

export default function CompanySections({companysectionlist,companyinfo,type,companymainLabelsList,isFollowed}) {
  console.log("company basic data ",companyinfo);
  const { compratiodefault , compratiodefloading } = useCompanyFin();
  console.log("compratiodefault data ",compratiodefault);
const isDataEmpty =
  !compratiodefloading &&
  Object.keys(compratiodefault || {}).length === 0;

  useEffect(() => {
  const hash = window.location.hash.replace('#', '');

  if (hash) {
    setTimeout(() => {
      scroller.scrollTo(hash, {
        smooth: true,
        offset: -80,
        duration: 500,
      });
    }, 300); // wait for render
  }
}, []);

if (isDataEmpty) {
  return (
    <div className="space-y-10 px-0 md:p-8">
      <Element name="section1" id="section1">
        <CompanyBasicSection
          companyinfo={companyinfo}
          companymainLabelsList={companymainLabelsList}
          isFollowed={isFollowed}
        />
      </Element>
       <section className="w-full bg-white rounded-2xl shadow-md border border-gray-100 p-10 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-3xl">
          ⚠️
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-800">
        Data Not Available
      </h3>
      <p className="mt-3 text-sm text-gray-600 max-w-md mx-auto">
        Our team is working to update this information. Please check back later.
      </p>
    </section>
    </div>
  );
}

return (
  <div className="space-y-10 px-0 md:p-8">
    
    {companysectionlist
      .filter((val) => {
        if (isDataEmpty) {
          return val.id === "company";
        }
        return true;
      })
      .map((val) => (
        <Element key={val.id} name={val.id} id={val.id}>
          {val.id === "company" ? (
            <CompanyBasicSection
              companyinfo={companyinfo}
              companymainLabelsList={companymainLabelsList}
              isFollowed={isFollowed}
            />
          )
          : val.id === "technical" ? (
            <Suspense fallback={<Loaderanimation count={10} />}>
              <AnalysisSection companyinfo={companyinfo} />
            </Suspense>
          ) 
          : val.id === "chart" ? (
        <StockChartSection companyinfo={companyinfo} />
      ) 
      
      : val.id === "investors" ? (
         <Suspense fallback={<Loaderanimation count={10} />}>
          <Investorsection companyinfo={companyinfo} />
         </Suspense>
      ) : 
       val.id === "industry" ? (
        <Peersection companyinfo={companyinfo} />
      ) 
      : 
       val.id === "quarterlyResult" ? (
        <Suspense fallback={<Loaderanimation  count={10}/>}>
        <QuarterResultSection companyinfo={companyinfo} type={type} />
        </Suspense>
      ) 
      : 
       val.id === "balanceSheet" ? (
        <BalancesheetSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "profitNLoss" ? (
        <ProfitNLossSection companyinfo={companyinfo} type={type} />
      ) 
       :
       val.id === "cashflow" ? (
        <CashFlowSection companyinfo={companyinfo} type={type} />
      ) 
       : 
       val.id === "ratios" ? (
        <RatioSection companyinfo={companyinfo} type={type} />
      )
      :
      val.id === "concall"? (
      	<CompanyConcall tag={companyinfo.symbol} />
      ) 
       : 
       val.id === "forumNnews" ? (
        <><Forumsection companyinfo={companyinfo} />   
        <CompanyNews tag={companyinfo.symbol} />  
        </>
      ) 
      :
       (<section className="bg-white shadow-md z-50 rounded-xl p-5">
          <h1 className="text-3xl font-bold">{val.label}</h1>
          <p className="mt-4">Check back soon.</p>
        </section>
      )}
        </Element>
      ))}

     {/*isDataEmpty && (
      <section className="w-full bg-white rounded-2xl shadow-md border border-gray-100 p-10 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 text-3xl">
          ⚠️
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-800">
        Data Not Available
      </h3>
      <p className="mt-3 text-sm text-gray-600 max-w-md mx-auto">
        Our team is working to update this information. Please check back later.
      </p>
    </section>
    )*/}
    {!isDataEmpty && (
      <Suspense fallback={<Loaderanimation count={10} />}>
        <CompanyFAQ companyinfo={companyinfo} type={type} />
      </Suspense>
    )}
  </div>
);
}
